<div class="box-table">
	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().MA_AP_TABLE_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>
	@if (apMeasuresForm) {
	<form [formGroup]="apMeasuresForm">
		<table aria-label="AP mechanical measures" class="table" [ngbCollapse]="isCollapsed">
			<thead>
				<tr>
					<th></th>
					<th>{{ labels().MA_AP_TABLE_COMPONENT_VALUE_HEADER }} <br />
						({{ (isLeft ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})
					</th>
					<th>{{ labels().MA_AP_TABLE_COMPONENT_TARGET_HEADER }}</th>
					<th>{{ labels().MA_AP_TABLE_COMPONENT_CONTROLATERAL_HEADER }} <br />
						({{ (isLeft ? sideEnum.Right : sideEnum.Left) | anatomicalSideLabel }})</th>
				</tr>
			</thead>
			<tbody>
				@if (isMAD) {
				<tr [class.row-selected]="!isValidMAD">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_MAD }} <br /> {{ rangeMAD }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_MAD">{{ defAPMeasures?.def_ap_MAD }}</td>
					<td class="align-middle"></td>
					<td [highlightCell]="defCLMeasures?.def_ap_MAD_ctrlateral">{{ defCLMeasures?.def_ap_MAD_ctrlateral }}</td>
				</tr>
				}
				@if (isMNSA) {
				<tr [class.row-selected]="!isValidMNSA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_MNSA }} <br /> {{ rangeMNSA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_MNSA">{{ defAPMeasures?.def_ap_MNSA }}</td>
					<td class="align-middle"></td>
					<td [highlightCell]="defCLMeasures?.def_ap_MNSA_ctrlateral">{{ defCLMeasures?.def_ap_MNSA_ctrlateral }}</td>
				</tr>
				}
				@if (isLPFA) {
				<tr [class.row-selected]="!isValidLPFA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_LPFA }} <br /> {{ rangeLPFA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_LPFA">{{ defAPMeasures?.def_ap_LPFA }}</td>
					<td class="align-middle">
						<input type="text" maxlength="2" name="LPFA" formControlName="LPFA" (keyup.enter)="updateStandardLPFA()"
							(blur)="updateStandardLPFA()" [readonly]="isDisableStandardLPFA"
							[class.is-invalid]="apMeasuresForm.controls['LPFA'].invalid" />
					</td>
					<td [highlightCell]="defCLMeasures?.def_ap_LPFA_ctrlateral">
						<span class="material-icons copy-value" [class.disabled]="isDisableCopyLPFA" (click)="copyStandardLPFA()"
							(keypress)="copyStandardLPFA()">file_copy</span>
						{{ defCLMeasures?.def_ap_LPFA_ctrlateral }}
					</td>
				</tr>
				}
				@if (isMPFA) {
				<tr [class.row-selected]="!isValidMPFA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_MPFA }} <br /> {{ rangeMPFA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_MPFA">{{ defAPMeasures?.def_ap_MPFA }}</td>
					<td class="align-middle"></td>
					<td [highlightCell]="defCLMeasures?.def_ap_MPFA_ctrlateral">{{ defCLMeasures?.def_ap_MPFA_ctrlateral }}</td>
				</tr>
				}
				@if (isMLDFA) {
				<tr [class.row-selected]="!isValidMLDFA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_MLDFA }} <br /> {{ rangeMLDFA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_mLDFA">{{ defAPMeasures?.def_ap_mLDFA }}</td>
					<td class="align-middle">
						<input type="text" maxlength="2" name="MLDFA" formControlName="MLDFA" (keyup.enter)="updateStandardMLDFA()"
							(blur)="updateStandardMLDFA()" [readonly]="isDisableStandardMLDFA"
							[class.is-invalid]="apMeasuresForm.controls['MLDFA'].invalid" />
					</td>
					<td [highlightCell]="defCLMeasures?.def_ap_mLDFA_ctrlateral">
						<span class="material-icons copy-value" [class.disabled]="isDisableCopyMLDFA" (click)="copyStandardMLDFA()"
							(keypress)="copyStandardMLDFA()">file_copy</span>
						{{ defCLMeasures?.def_ap_mLDFA_ctrlateral }}
					</td>
				</tr>
				}
				@if (isJLCA) {
				<tr [class.row-selected]="!isValidJLCA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_KNEE_JLCA }} <br /> {{ rangeJLCA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_JLCA">{{ defAPMeasures?.def_ap_JLCA }}</td>
					<td class="align-middle"></td>
					<td [highlightCell]="defCLMeasures?.def_ap_JLCA_ctrlateral">{{ defCLMeasures?.def_ap_JLCA_ctrlateral }}</td>
				</tr>
				}
				@if (isKneeTransl) {
				<tr [class.row-selected]="!isValidKneeTransl">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_KNEE_TRANSL }} <br /> {{ rangeKneeTransl }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_kneeTranslation">
						{{ defAPMeasures?.def_ap_kneeTranslation }}</td>
					<td class="align-middle"></td>
					<td [highlightCell]="defCLMeasures?.def_ap_kneeTranslation_ctrlateral">
						{{ defCLMeasures?.def_ap_kneeTranslation_ctrlateral }}</td>
				</tr>
				}
				@if (isMPTA) {
				<tr [class.row-selected]="!isValidMPTA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_MPTA }} <br /> {{ rangeMPTA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_MPTA">{{ defAPMeasures?.def_ap_MPTA }}</td>
					<td class="align-middle">
						<input type="text" maxlength="2" name="MPTA" formControlName="MPTA" (keyup.enter)="updateStandardMPTA()"
							(blur)="updateStandardMPTA()" [readonly]="isDisableStandardMPTA"
							[class.is-invalid]="apMeasuresForm.controls['MPTA'].invalid" />
					</td>
					<td [highlightCell]="defCLMeasures?.def_ap_MPTA_ctrlateral">
						<span class="material-icons copy-value" [class.disabled]="isDisableCopyMPTA" (click)="copyStandardMPTA()"
							(keypress)="copyStandardMPTA()">file_copy</span>
						{{ defCLMeasures?.def_ap_MPTA_ctrlateral }}
					</td>
				</tr>
				}
				@if (isLDTA) {
				<tr [class.row-selected]="!isValidLDTA">
					<td class="align-middle">{{ labels().MA_AP_TABLE_COMPONENT_LDTA }} <br /> {{ rangeLDTA }}</td>
					<td class="align-middle" [highlightCell]="defAPMeasures?.def_ap_LDTA">{{ defAPMeasures?.def_ap_LDTA }}</td>
					<td class="align-middle">
						<input type="text" maxlength="2" name="LDTA" formControlName="LDTA" (keyup.enter)="updateStandardLDTA()"
							(blur)="updateStandardLDTA()" [readonly]="isDisableStandardLDTA"
							[class.is-invalid]="apMeasuresForm.controls['LDTA'].invalid" />
					</td>
					<td [highlightCell]="defCLMeasures?.def_ap_LDTA_ctrlateral">
						<span class="material-icons copy-value" [class.disabled]="isDisableCopyLDTA" (click)="copyStandardLDTA()"
							(keypress)="copyStandardLDTA()">file_copy</span>
						{{ defCLMeasures?.def_ap_LDTA_ctrlateral }}
					</td>
				</tr>
				}
			</tbody>
		</table>
	</form>
	}
</div>